export default __webpack_public_path__ + "static/media/p7-12.290273a6.png";